(ns teamoesterreich.admin-mode.questionnaire.questionnaire-detail-form
  (:require [clojure.string]
            [reagent-material-ui.components :as mui]
            [reagent.core :as r]
            [teamoesterreich.admin-mode.data.backend :as backend]
            [teamoesterreich.util.helper :as h]             ;;(h/event-value e)
            [teamoesterreich.view-state :as vstate]
            [teamoesterreich.admin-mode.ui-helper.editable-markdown-card :as edit-md-card]

            [teamoesterreich.admin-mode.modal.are-you-sure-modal :as are-you-sure-modal]
            [teamoesterreich.admin-mode.data.rights :as d-rights]
            [teamoesterreich.admin-mode.data.questionnaire :as d-questionnaire]

            [reagent-material-ui.icons.edit :refer [edit]]
            [reagent-material-ui.icons.save :refer [save]]
            [reagent-material-ui.icons.send :refer [send]]
            [reagent-material-ui.icons.delete-forever :refer [delete-forever]]
            [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.util.markdown :refer [md]]))


(defn isSet-or [a b] (if (nil? a) b a))

(defn datetime-conv [dateTime]
  ;20180701T100000.000Z -> 2021-06-20T23:24
  (if (> (count dateTime) 12)
    (str (subs dateTime 0 4) "-" (subs dateTime 4 6) "-" (subs dateTime 6 8) "T" (subs dateTime 9 11) ":" (subs dateTime 11 13)
         )
    ""
    ))
(defn datetime-conv-back [dateTime]
  ;2021-06-20T23:24 -> 20180701T100000.000Z
  (str (subs dateTime 0 4) (subs dateTime 5 7) (subs dateTime 8 10) "T" (subs dateTime 11 13) (subs dateTime 14 16) "00.000Z"))

(defn get-base [!questionnaire disabled reload-fn]
  (let [!st (r/atom {:edit-mode false :data {}})
        !edit-mode (r/cursor !st [:edit-mode])
        !publish-popup (r/cursor !st [:publish-popup])
        !data (r/cursor !st [:data])]
    (fn []
      (let [has-edit-right false
            changed? (fn [key]
                       (log/debug "changed?" key (exists? (get @!data key)) (not= (get @!data key) (get @!questionnaire key)))
                       (and (exists? (get @!data key)) (not= (get @!data key) (get @!questionnaire key))))
            has-changes? (or
                           (changed? :questionnaireQuestionnaire-name)
                           (changed? :questionnaireQuestionnaire-locationName)
                           (changed? :questionnaireQuestionnaire-acceptableUntil)
                           (changed? :questionnaireQuestionnaire-timeFrom)
                           (changed? :questionnaireQuestionnaire-timeTo)
                           (changed? :questionnaireQuestionnaire-appearenceLocation)
                           (changed? :questionnaireQuestionnaire-appearenceSelf)
                           (changed? :questionnaireQuestionnaire-sumPoints)
                           )
            change-fn (fn [key value] (swap! !data assoc key value))
            ]
        [mui/card
         ;(log/debug "rerender form " @!data)
         [mui/card-header {:title "Fragebogen Details"}]
         [mui/card-content
          [mui/grid
           {:container  true
            :direction  "row"
            :justify    "flex-start"
            :alignItems "flex-start"
            :spacing    3
            :style      {:margin "15px 0 0 0"}
            }

           [mui/grid
            {:container false :item true
             :md        6
             :xs        12
             :style     {:padding "5px"}
             }
            [mui/text-field {
                             :style        {:backgroundColor (if (changed? :questionnaireQuestionnaire-name) "#ffd6d2" "#ffffff")}
                             :fullWidth    true
                             :disabled     (not @!edit-mode)
                             :defaultValue (str (:questionnaireQuestionnaire-name @!questionnaire))
                             :onChange     (fn [e] (change-fn :questionnaireQuestionnaire-name (h/event-value e)))
                             :label        "Fragebogen Name"}]
            ]
           [mui/grid
            {:container false :item true
             :md        6
             :xs        12
             :style     {:padding "5px"}
             }
            [mui/form-group
             [mui/form-control-label
              {:style     {:paddingLeft "126px" :backgroundColor (if (changed? :questionnaireQuestionnaire-appearenceSelf) "#ffd6d2" "#ffffff")}
               :label     "Persönlicher Fragebogen"
               :fullWidth true
               :control   (r/as-element
                            [mui/switch
                             {:style    {}
                              :disabled (not @!edit-mode)
                              :checked  (isSet-or (get @!data :questionnaireQuestionnaire-appearenceSelf) (get @!questionnaire :questionnaireQuestionnaire-appearenceSelf))
                              :onChange (fn [_ e] (change-fn :questionnaireQuestionnaire-appearenceSelf e))
                              }])}
              ]]

            [mui/form-group
             [mui/form-control-label
              {:style     {:paddingLeft "126px" :backgroundColor (if (changed? :questionnaireQuestionnaire-appearenceLocation) "#ffd6d2" "#ffffff")}
               :label     "Standort Fragebogen"
               :fullWidth true
               :control   (r/as-element
                            [mui/switch
                             {:style    {}
                              :disabled (not @!edit-mode)
                              :checked  (isSet-or (get @!data :questionnaireQuestionnaire-appearenceLocation) (get @!questionnaire :questionnaireQuestionnaire-appearenceLocation))
                              :onChange (fn [_ e] (change-fn :questionnaireQuestionnaire-appearenceLocation e))
                              }])}
              ]]

            ]
           [mui/grid
            {:container false :item true
             :md        3                                   ;medium: 960px
             :xs        12                                  ;extra-small: 0px
             :style     {:padding "5px"}
             }
            [mui/text-field {
                             :style           {:backgroundColor (if (changed? :questionnaireQuestionnaire-timeFrom) "#ffd6d2" "#ffffff")}
                             :fullWidth       true
                             :disabled        (not @!edit-mode)
                             :type            "datetime-local"
                             :autoOk          true
                             :label           "Beginn"
                             :InputLabelProps {:disableAnimation true :shrink true}
                             :onChange        (fn [e]
                                                (let [date (h/event-value e)
                                                      date (datetime-conv-back date)]
                                                  (change-fn :questionnaireQuestionnaire-timeFrom date)))
                             :defaultValue    (datetime-conv (:questionnaireQuestionnaire-timeFrom @!questionnaire))
                             }]]

           [mui/grid
            {:container false :item true
             :md        3                                   ;medium: 960px
             :xs        12                                  ;extra-small: 0px
             :style     {:padding "5px"}
             }

            [mui/text-field {
                             :style           {:backgroundColor (if (changed? :questionnaireQuestionnaire-acceptableUntil) "#ffd6d2" "#ffffff")}
                             :fullWidth       true
                             :disabled        (not @!edit-mode)
                             :type            "datetime-local"
                             :autoOk          true
                             :label           "Ende"
                             :InputLabelProps {:disableAnimation true :shrink true}
                             :onChange        (fn [e]
                                                (let [date (h/event-value e)
                                                      date (datetime-conv-back date)]
                                                  (change-fn :questionnaireQuestionnaire-acceptableUntil date)))
                             :defaultValue    (datetime-conv (:questionnaireQuestionnaire-acceptableUntil @!questionnaire))
                             }]

            ]
           [mui/grid
            {:container false :item true
             :md        5                                   ;medium: 960px
             :xs        12                                  ;extra-small: 0px
             :style     {:padding "5px"}
             }


            [mui/text-field {
                             :style        {:backgroundColor (if (changed? :questionnaireQuestionnaire-sumPoints) "#ffd6d2" "#ffffff")}
                             :fullWidth    true
                             :disabled     (not @!edit-mode)
                             :defaultValue (str (:questionnaireQuestionnaire-sumPoints @!questionnaire))
                             :onChange     (fn [e] (change-fn :questionnaireQuestionnaire-sumPoints (h/event-value e)))
                             :label        (str "Punkte Ziel (rMax: " (int (:_questionnaireQuestionnaire-maxPoints @!questionnaire)) ")")}]

            ]
           ]
          [mui/card-actions
           ]
          [mui/card-actions
           (when (and (not @!edit-mode) (not disabled))
             [mui/button {
                          :variant   "contained"
                          :startIcon (r/as-element [edit])
                          :onClick   #(reset! !edit-mode true)
                          } "Bearbeiten"])

           (when (and @!edit-mode)
             [mui/button {
                          :variant   "contained"
                          :startIcon (r/as-element [keyboard-arrow-left])
                          } "Abbrechen"])

           (when (and @!edit-mode)
             [mui/button {
                          :variant   "contained"
                          :color     "primary"
                          :startIcon (r/as-element [save])
                          :disabled  (not has-changes?)
                          :onClick   (fn []
                                       (d-questionnaire/>questionnaire-edit (:questionnaireQuestionnaire-uuid @!questionnaire) @!data reload-fn))
                          } "Speichern"])

           [mui/form-group
            [mui/form-control-label
             {:style     {:paddingLeft "126px" :backgroundColor (if (changed? :questionnaireQuestionnaire-appearenceSelf) "#ffd6d2" "#ffffff")}
              :label     "Veröffentlichen"
              :fullWidth true
              :control   (r/as-element
                           [mui/switch
                            {:style    {}
                             :disabled (not @!edit-mode)
                             :checked  (isSet-or (get @!data :questionnaireQuestionnaire-published) (get @!questionnaire :questionnaireQuestionnaire-published))
                             :onChange (fn [_ e]
                                         (d-questionnaire/>questionnaire-edit (:questionnaireQuestionnaire-uuid @!questionnaire) {:questionnaireQuestionnaire-published e
                                                                                                                                  :questionnaireQuestionnaire-active e} reload-fn))
                             }])}
             ]]


           ]
          ]

         ]))))

(defn get-briefing [!questionnaire disabled reload-fn]
  (let []
    (fn []
      (let [save-fn (fn [text]
                      (d-questionnaire/>questionnaire-edit (:questionnaireQuestionnaire-uuid @!questionnaire) {:questionnaireQuestionnaire-description text}
                                                           reload-fn)
                      )]
        [:div
         (if disabled
           [:div
            [:h3 "Beschreibung"]
            [:div {:dangerouslySetInnerHTML {:__html (.render md (or (get @!questionnaire :questionnaireQuestionnaire-description) ""))}
                   :className               "editor-preview-widget"
                   :style                   {:width "45%" :margin-left "5%" :display "inline-block" :vertical-align "top" :textAlign "left" :minHeight "400px" :padding "10px" :border "1px dotted grey"}}]]
           [(edit-md-card/get-it (get @!questionnaire :questionnaireQuestionnaire-description) save-fn (str backend/BASE_URL "/media-upload") "Fragebogen Beschreibung"
                                 ""
                                 )]
           )]
        ))))


(defn get-it [!questionnaire !publish-popup-show reload-fn]
  (let [allowEdit (d-rights/allow-admin-for d-rights/CONTENT)]
    [mui/card-content {}
     [(get-base !questionnaire (not allowEdit) reload-fn)]
     [:br]
     [(get-briefing !questionnaire (not allowEdit) reload-fn)]
     [:br]
     [mui/card-actions

      [mui/button {:startIcon (r/as-element [keyboard-arrow-left])
                   :onClick   #(swap! vstate/app-state assoc
                                      :edit-questionnaire {}
                                      :questionnaire-detail-loaded false
                                      :site :questionnaire-list
                                      )
                   }
       "Schließen"
       ]
      (when allowEdit
        [mui/form-group
         [are-you-sure-modal/are-you-sure-modal !publish-popup-show
          "Bist du sicher, dass du diesen Fragebogen veröffentlichen möchtest? Alle Mitglieder werden ihn sehen können!" "Ja veröffentlichen"
          (fn [_] (d-questionnaire/>questionnaire-edit (:questionnaireQuestionnaire-uuid @!questionnaire) {:questionnaireQuestionnaire-published true} reload-fn))]
         [mui/form-control-label
          {:style     {:paddingLeft "126px"}
           :label     "Fragebogen veröffentlichen"
           :fullWidth true
           :control   (r/as-element
                        [mui/switch
                         {
                          :checked  (or (get @!questionnaire :questionnaireQuestionnaire-published) false)
                          :onChange (fn [_ v] (if v (reset! !publish-popup-show true)
                                                    (d-questionnaire/>questionnaire-edit (:questionnaireQuestionnaire-uuid @!questionnaire) {:questionnaireQuestionnaire-published false} reload-fn)))
                          }])}
          ]]

        [mui/button {:startIcon (r/as-element [delete-forever])
                     :color     "secondary"
                     :style     {:marginLeft "150px"}
                     }
         "Löschen"
         ]
        )
      ]
     ]))